import { render, staticRenderFns } from "./ClaimsPortal.vue?vue&type=template&id=69972fc1&scoped=true&"
import script from "./ClaimsPortal.vue?vue&type=script&lang=js&"
export * from "./ClaimsPortal.vue?vue&type=script&lang=js&"
import style0 from "./ClaimsPortal.vue?vue&type=style&index=0&id=69972fc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69972fc1",
  null
  
)

export default component.exports